import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { Button, Grid, makeStyles, SubmitButton, Tabs, ClientForm, BillingInfoForm, Dialog, PersonOfContactForm, FaceForm } from "../../.."; // import { Debug } from '../../../Molecules/Forms/Debug';

import selects from "../../../assets/selects";
var contactSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  type: Yup.string(),
  email: Yup.string().email().min(4, "Introduce un email"),
  // these constraints take precedence
  phone: Yup.string(),
  clientType: Yup.string().required(),
  billingInfo: Yup.object().when("face", {
    is: true,
    then: Yup.object().shape({
      face_data: Yup.object().shape({
        codeGestor: Yup.string().required(),
        nameGestor: Yup.string().required(),
        addressGestor: Yup.string().required(),
        zipCodeGestor: Yup.string().required(),
        townGestor: Yup.string().required(),
        provinceGestor: Yup.string().required(),
        codeTramitador: Yup.string().required(),
        nameTramitador: Yup.string().required(),
        addressTramitador: Yup.string().required(),
        zipCodeTramitador: Yup.string().required(),
        townTramitador: Yup.string().required(),
        provinceTramitador: Yup.string().required(),
        codeContable: Yup.string().required(),
        nameContable: Yup.string().required(),
        addressContable: Yup.string().required(),
        zipCodeContable: Yup.string().required(),
        townContable: Yup.string().required(),
        provinceContable: Yup.string().required()
      })
    }).required("Required field")
  })
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    taxName: {
      "margin-right": "30px",
      width: "40%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    mr30: {
      "margin-right": "30px"
    }
  };
});

var DialogContact = function DialogContact(_ref) {
  var from = _ref.from,
      translation = _ref.translation,
      contact = _ref.contact,
      props = _objectWithoutProperties(_ref, ["from", "translation", "contact"]);

  // console.log("DialogContact", props, from, translation, contact);
  var _useState = useState("client"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var initialValues = props.variant === "add" ? {
    name: "",
    type: "client",
    billingInfo: {
      name: ""
    },
    city: "",
    email: "",
    telephone: "",
    clientType: "",
    web: "",
    people: []
  } : contact;

  var handleTabs = function handleTabs(event, newValue) {
    return setValue(newValue);
  };

  var classes = useStyles();
  var title = "";

  var contentTabHandler = function contentTabHandler(values, setFieldValue) {
    switch (value) {
      case "client":
        return /*#__PURE__*/React.createElement(ClientForm, {
          values: values,
          mode: props.variant,
          translation: translation ? translation.forms.client : null
        });

      case "person_of_contact":
        return /*#__PURE__*/React.createElement(PersonOfContactForm, {
          values: values,
          mode: props.variant,
          translation: translation ? translation.forms.person_of_contact : null
        });

      case "billing":
        return /*#__PURE__*/React.createElement(BillingInfoForm, {
          contact: true,
          values: values,
          mode: props.variant,
          translation: translation ? translation.forms.billing_info : null
        });

      case "face":
        return /*#__PURE__*/React.createElement(FaceForm, {
          contact: true,
          values: values,
          mode: props.variant // translation={translation ? translation.forms.billing_info : null}

        });

      default:
        return /*#__PURE__*/React.createElement(ClientForm, {
          values: values,
          mode: props.variant,
          translation: translation ? translation.forms.client : null
        });
    }
  };

  if (props.variant === "edit") {
    title = translation ? translation.titles.edit_contact : "Edit Contact";
  } else if (props.variant === "view") {
    title = translation ? translation.titles.view_contact : "View Contact";
  } else if (props.variant === "add") {
    title = translation ? translation.titles.add_contact : "Add Contact";
  }

  var contentDialog = function contentDialog() {
    // console.log("translation en contentDialog", translation);
    // console.log("hey dialog");
    // switch (props.variant) {
    //   case "add":
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.root
    }, /*#__PURE__*/React.createElement(Formik, {
      initialValues: props.data || initialValues,
      validationSchema: contactSchema,
      onSubmit: function onSubmit(values) {
        if (props.variant === "add") {
          props.createContact(values);
        } else if (props.variant === "edit") {
          props.editContact(values);
        }

        props.onClose();
      },
      render: function render(_ref2) {
        var values = _ref2.values,
            setFieldValue = _ref2.setFieldValue,
            handleBlur = _ref2.handleBlur,
            isValid = _ref2.isValid,
            isSubmitting = _ref2.isSubmitting;
        return /*#__PURE__*/React.createElement(Form, {
          "data-cy": "add-contact"
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.root
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.flex
        }, /*#__PURE__*/React.createElement(Field, {
          "data-cy": "name",
          name: "name",
          key: "name",
          className: classes.w50,
          label: translation ? translation.inputs.contact_name : "Name",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          disabled: props.variant === "view"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12
        }, /*#__PURE__*/React.createElement(Tabs, {
          value: value,
          onChange: handleTabs,
          variant: "standard",
          indicatorColor: "primary",
          textColor: "primary",
          contentTabs: props.variant === "add" ? translation ? translation.tabs : selects.client_tabs : translation ? translation.tabs_edit : selects.client_tabs_edit
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.editor
        }, contentTabHandler(values)), props.variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          "data-cy": "cancel",
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, translation ? translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
          "data-cy": "submit",
          size: "medium",
          className: classes.mr30,
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, translation ? translation.buttons.save : "Save"))));
      }
    })); // case "edit":
    //   return (
    //     <Grid container className={classes.root}>
    //       <Formik
    //         initialValues={props.data || initialValues}
    //         validationSchema={contactSchema}
    //         onSubmit={values => {
    //           if (props.variant === "add") {
    //             props.createContact(values);
    //           } else if (props.variant === "edit") {
    //             props.editContact(values);
    //           }
    //           props.onClose();
    //         }}
    //         render={({
    //           values,
    //           setFieldValue,
    //           handleBlur,
    //           isValid,
    //           isSubmitting,
    //           errors
    //         }) => {
    //           // console.log('erro/rs', errors)
    //           return (
    //             <Form className={classes.form}>
    //               <Grid container className={classes.root}>
    //                 <Grid item md={12} className={classes.flex}>
    //                   <Field
    //                     name="name"
    //                     className={classes.w50}
    //                     label={
    //                       translation
    //                         ? translation.inputs.contact_name
    //                         : "Name"
    //                     }
    //                     component={TextField}
    //                     margin="normal"
    //                     variant="outlined"
    //                     disabled={props.variant === "view"}
    //                   />
    //                   <Field
    //                     name="billingInfo.name"
    //                     label={
    //                       translation
    //                         ? translation.inputs.billing_info_name
    //                         : "Tax Name"
    //                     }
    //                     className={[
    //                       classes.taxName,
    //                       classes.w50,
    //                       classes.mr30
    //                     ].join(" ")}
    //                     component={TextField}
    //                     margin="normal"
    //                     variant="outlined"
    //                     disabled={props.variant === "view"}
    //                   />
    //                 </Grid>
    //                 <Grid item md={12} className={classes.editor}>
    //                   {contentTabHandler("client")}
    //                 </Grid>
    //                 <Grid container className={classes.actions}>
    //                   <Button
    //                     type="button"
    //                     size="medium"
    //                     className={classes.mr30}
    //                     color="secondary"
    //                     variant="outlined"
    //                     onClick={props.onClose}
    //                   >
    //                     {translation ? translation.buttons.cancel : "Cancel"}
    //                   </Button>
    //                   <Button
    //                     size="medium"
    //                     className={classes.mr30}
    //                     color="primary"
    //                     variant="outlined"
    //                     disabled={!isValid || isSubmitting}
    //                     component={SubmitButton}
    //                     type="submit"
    //                   >
    //                     {translation ? translation.buttons.save : "Save"}
    //                   </Button>
    //                 </Grid>
    //                 {/* <Debug /> */}
    //               </Grid>
    //             </Form>
    //           );
    //         }}
    //       />
    //     </Grid>
    //   );
    //   default:
    //     break;
    // }
  };

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant
  }, contentDialog())];
};

export { DialogContact };